import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';
import { Observable } from 'rxjs';
import {
  Text,
  parseTextAddBrTags
} from 'src/app/services/xml-parser-service/xml-parser.service';
import { PageService } from '../../service/page-service.service';
import { VisibilityWatchers } from '../visibility-watchers/visibility-watchers';

@Component({
  selector: 'app-content-text',
  templateUrl: './content-text.component.html',
  styleUrls: ['./content-text.component.css'],
  standalone: false
})
export class ContentTextComponent implements OnChanges, OnDestroy {
  @Input() item: Text;

  text: Text;
  ready: boolean;
  textValue: string;
  isFirstPage$: Observable<boolean>;
  dir$: Observable<string>;
  textColor: string;
  styles: { [key: string]: string | number };
  startImgResource: string | null;
  startImgWidth: string | null;
  visibility: VisibilityWatchers;

  constructor(private pageService: PageService) {
    this.isFirstPage$ = pageService.isFirstPage$;
    this.dir$ = this.pageService.pageDir$;
    this.visibility = new VisibilityWatchers(this.pageService);
  }

  ngOnDestroy(): void {
    this.visibility.closeWatchers();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'item': {
            if (
              !changes['item'].previousValue ||
              changes['item'].currentValue !== changes['item'].previousValue
            ) {
              this.ready = false;
              this.textValue = '';
              this.text = this.item as Text;
              this.init();
            }
          }
        }
      }
    }
  }

  private init(): void {
    this.visibility.init(this.text);

    const styles = {
      'font-weight': this.text.fontWeight ? this.text.fontWeight : '',
      'font-style': this.text.textStyles?.some(
        (style) => style.name === 'ITALIC'
      )
        ? 'italic'
        : '',
      'text-decoration': this.text.textStyles?.some(
        (style) => style.name === 'UNDERLINE'
      )
        ? 'underline'
        : '',
      'justify-content': this.text.textAlign.name || '',
      'font-size': this.text.textScale ? `${this.text.textScale}rem` : '',
      'line-height': this.text.textScale
        ? `${this.text.textScale * 1.25}rem`
        : '',
      'min-height': this.text.minimumLines ? `${this.text.minimumLines}em` : ''
      // Do not use color for now since we don't want to support desktop and mobile colors
      // color: this.text.textColor || ''
    };

    this.startImgResource = this.pageService.getResourceUrl(
      this.item.startImage
    );
    this.startImgWidth = this.item.startImageSize
      ? this.item.startImageSize + 'px'
      : null;

    this.textColor = this.text?.textColor || null;
    this.styles = styles;
    const text = parseTextAddBrTags(this.text.text);
    this.textValue = text || '';
    this.ready = true;
  }
}
